export default {
  MazegameTitle: 'Maze Game Settings',
  topic: 'Game Topic',
  inputTopic: 'Enter game topic',
  questionSettings: 'Question Settings',
  questionNumber: 'Question',
  options: 'Options',
  addOption: 'Add Option',
  addQuestion: 'Add Question',
  removeQuestion: 'Remove Question',
  removeOption: 'Remove Option',
  questionText: 'Question',
  inputQuestionText: 'Enter question text',
  optionSettings: 'Option Settings (2-4 options)',
  optionContent: 'Option Content',
  setCorrectAnswer: 'Set as Correct Answer',
  clearData: 'Clear Data',
  saveSettings: 'Save Settings',
  maxQuestions: 'Maximum 10 questions allowed',
  maxOptions: 'Maximum 4 options allowed',
  minOptions: 'At least 2 options required',
  questionExists: 'This question already exists',
  settingsSaved: 'Settings saved',
  pleaseCompleteSettings: 'Please complete all required fields',

  // Game Screen
  pauseButton: 'Pause',
  resumeButton: 'Resume',
  exitButton: 'Exit',
  restartButton: 'Restart',
  progress: 'Progress',
  question: 'Question',
  totalQuestions: 'Total Questions',
  gamePaused: 'Game Paused',

  // Feedback Messages
  correctAnswerMsg: 'Correct! 🎉',
  wrongAnswer: 'Wrong answer, try again!',
  gameCompleted: 'Congratulations! All questions completed!',
  gameOver: 'Game Over',

  // Result Screen
  finalScore: 'Final Score',
  accuracy: 'Accuracy',
  timeSpent: 'Time Spent',
  wrongAttempts: 'Wrong Attempts',

  // Control Hints
  controlHint: 'Use arrow keys to move',
  findCorrectExit: 'Find the correct exit',

  // Reference Answers
  referenceAnswers: 'Reference Answers',
  sendSuccess: 'Game data has been successfully pushed!',
  sendCooldown: 'Already sent, please wait 1 minute before trying again',

  // New Push Feature
  pushSuccess: 'Game activity has been successfully pushed!',
  pushFailed: 'Push failed: {message}',
  tokenRefreshing: 'Refreshing authorization, please try again later...',

  // Small screen warning
  smallScreenWarning: 'This game is designed for desktop use. Recommended for computer or tablet with minimum screen width of 1200px*800px',
  currentRank: 'Current Rank',
  totalParticipants: 'Total Participants',
};
